export const IMPERSONATING_USER = 'impersonatingUser';

export const DEFAULT_CATEGORY = 'Societe Generale'; // never translated

export const DEFAULT_SGM_CATEGORY = 'SG Markets'; // never translated

export const TRACKING_SEARCH_TERM_KEY = 'searched-term';

export const NON_SGM_RELATED_TO_PLATFORM_SGM = 'SGM';

export const MARKETS_CATEGORY = 'services.category.markets';

export const DEFAULT_LANGUAGE = 'en';

export type languages = 'en' | 'fr' | 'es' | 'de' | 'ja' | 'zh' | 'it' | 'pt';

export const ALL_LANGUAGES: languages[] = ['de', 'fr', DEFAULT_LANGUAGE, 'es', 'ja', 'zh'];
